import React, {useEffect, useState} from 'react';
import {Box, Typography} from "@mui/material";
import CircularProgress from '@mui/material/CircularProgress';
import {useLocation, useParams} from "react-router-dom";
import {BreadcrumbsComponent} from "../../../../components/UI/breadcrumb/BreadcrumbComponent";
import {
    buildMySamplesSectionPath,
    buildSystemSamplesPath,
    CUSTOMER_SAMPLES_SUBMENU_BREADCRUMB,
} from "../../../../utils/customerBreadcrumbLabels";
import CustomerDetailsTable from "../../../../components/UI/table/customer-detales/CustomerDetailsTable";
import {constantsErrorMessages} from "../../../../Constants";
import MaterialTree from "../../../../components/UI/tree/MaterialTree";
import GroupMaterialUtil from "../../../../utils/orders/GroupMaterialUtil";
import SamplesControllerServiceGroup from "../../../../API/samples/Customers/SamplesGroup";
import SamplesControllerService from "../../../../API/samples/Customers/SamplesController";
import {EditLocalStoragePagesData} from "../../../../utils/EditLocalStoragePagesData";
import SamplesControllerServiceGroupAdmin from "../../../../API/samples/Admin/SamplesGroupAdmin";
import TemplateControllerServiceGroup from "../../../../API/samples/Customers/SamplesGroup";
import SamplesControllerServiceAdmin from "../../../../API/samples/Admin/SamplesControllerAdmin";

const CustomerSamples = ({
                             system,
                             admin,
                             modal,
                             setSelectedSamples,
                             selectedSamples,
                             settings,
                             handleActiveItemsChange
                         }) => {
    const pathname = useLocation().pathname
    const params = useParams();
    const {orderId, customerOrderNumber, requestsCuttingId, requestsCuttingNumber} = params

    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);

    const [alertData, setAlertData] = useState({}); //type 'error'| 'info' | 'success'| 'warning'

    const [filterGroup, setFilterGroup] = useState(new Map());
    const [changeFilterGroup, setChangeFilterGroup] = useState(false);
    const [dataTree, setDataTree] = useState([]);
    const [groupMap, setGroupMap] = useState(null);
    const [currentGroup, setCurrentGroup] = useState(null);

    const [rowSelection, setRowSelection] = useState([]);

    const [data, setData] = useState([]);
    const [unable, setUnable] = useState({unableTurn: {}, unablePackage: {}});

    const [change, setChange] = useState(false);
    const [tableOptions, setTableOptions] = useState({pageIndex: 0, pageSize: 100, totalElements: 0, searchData: ""})

    const [expandedItems, setExpandedItems] = useState(['M']);

    const handleExpandedItemsChange = (event, itemIds) => {
        setExpandedItems(itemIds);
    };

    const handleToggle = (node) => {
        let id = node?.id


        const group = groupMap.get(id) || {}
        if (group !== null) {
            GroupMaterialUtil.addToFilterMapGroup(group, filterGroup)
            setFilterGroup(filterGroup);
            setChangeFilterGroup(!changeFilterGroup)
            setCurrentGroup(group)
        }
    };

    const handleModalAlert = (message, type = "error") => {
        setAlertData({
            type: type,
            open: true,
            message: type === "success" ? message : message.response?.data?.message || constantsErrorMessages[message.response?.status] || message.message
        })
    }
    const tableOptionsHandle = (nextState) => {

        if (nextState.pageSize !== tableOptions.pageSize) {
            setTableOptions(nextState)
            EditLocalStoragePagesData(pathname, "pageSize", nextState.pageSize)
        }
    }
    const getStartPageSize = () => {
        const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
        const pageSize = pagesData[pathname]?.pageSize
        pageSize && setTableOptions((prev) => ({...prev, pageSize: pageSize}))
    }

    const handleCloseAlert = () => {
        setAlertData((alert) => {
            return {...alert, open: false}
        })
    }

    useEffect(() => {
        const api = admin ? SamplesControllerServiceAdmin : SamplesControllerService
        currentGroup && api.getAll(tableOptions.pageIndex, tableOptions.pageSize, currentGroup, system)
            .then(function (response) {
                const data = response?.data.detailSamples
                setData(data);
                setTableOptions((prev) => ({...prev, totalElements: response?.data.totalElements}))
                setIsError(false)
            })
            .catch(function (error) {
                handleModalAlert(error)
            })
    }, [change, currentGroup, tableOptions.searchData, tableOptions.pageIndex, tableOptions.pageSize]);

    useEffect(() => {
        getStartPageSize()
        const api = admin ? SamplesControllerServiceGroupAdmin.getAll() : system ? SamplesControllerServiceGroup.getAllRoot() : SamplesControllerServiceGroup.getAll()
        api.then((response) => {
            const buildTreeGroups = GroupMaterialUtil.buildTreeGroupsSamples(response.data);
            setDataTree(buildTreeGroups);
            const groupMap = new Map();
            GroupMaterialUtil.addToMap(buildTreeGroups, groupMap)
            setGroupMap(groupMap);
            setCurrentGroup({})
        }).catch(function (error) {
            handleModalAlert(error)
        });
    }, []);


    return (
        isLoading ?
            <Box sx={{
                height: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            }}>
                <CircularProgress disableShrink/>
            </Box> :
            <Box sx={{
                overflow: 'auto',
                maxWidth: modal ? "85vw" : "2130px",
                padding: modal || settings ? "0px" : "0 30px"
            }}>
                {!modal && !admin && <BreadcrumbsComponent
                    page={CUSTOMER_SAMPLES_SUBMENU_BREADCRUMB.name}
                    path={system ? buildSystemSamplesPath() : buildMySamplesSectionPath()}
                />}
                {admin && <Typography sx={{fontSize: "24px", fontWeight: 700}}> Шаблоны системы</Typography>}
                <Box sx={{
                    display: 'flex',
                    alignItems: 'flex-start',
                }}>
                    <Box sx={{
                        flexBasis: '50%',
                        maxWidth: '500px',
                        paddingTop: Object.keys(rowSelection).length !== 0 ? "108px" : "49px"
                    }}>
                        <MaterialTree
                            name={"Группы"}
                            data={dataTree}
                            currentGroup={currentGroup}
                            setCurrentGroup={setCurrentGroup}
                            handleToggle={handleToggle}
                            expandedItems={expandedItems}
                            handleExpandedItemsChange={handleExpandedItemsChange}
                            height={modal ? "355px" : `calc(100vh - 265px)`}
                        />
                    </Box>
                    <Box sx={{
                        flexBasis: 'auto',
                        marginLeft: '16px',
                        overflow: 'auto',
                        borderTopLeftRadius: '3px',
                        borderTopRightRadius: '3px',
                        maxWidth: settings ? 'calc(100vw - 950px)' : 'calc(100vw - 600px)'
                    }}>
                        <CustomerDetailsTable
                            data={data}
                            materialTreeData={{dataTree, groupMap}}
                            setChange={setChange}
                            unableTurn={unable.unableTurn}
                            unablePackage={unable.unablePackage}
                            pageSize={100}
                            isError={isError}
                            setData={setData}
                            enableEditing={true}
                            orderId={orderId}
                            samples={true}
                            system={system}
                            admin={admin}
                            customerOrderNumber={customerOrderNumber}
                            requestsCuttingNumber={requestsCuttingNumber}
                            tableOptionsHandle={tableOptionsHandle}
                            tableOptions={tableOptions}
                            modal={modal}
                            selectedSamples={selectedSamples}
                            setSelectedSamples={setSelectedSamples}
                            handleActiveItemsChange={handleActiveItemsChange}
                        />
                    </Box>
                </Box>
            </Box>
    )
}
export default CustomerSamples
